<template>
    <v-dialog  max-width="500px">
        <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark  v-bind="attrs" v-on="on">
                    <v-icon small>mdi-plus</v-icon>
                    <span v-if="$vuetify.breakpoint.mdAndUp" class="ml-2">{{ $page.props.lang.addNote || "Add note" }}</span>
                </v-btn>
        </template>
        <template v-slot:default="addModal">
        <v-card>
                <div class="modal-header">
                    <h4 class="modal-headline">{{ $page.props.lang.addNote || "Add note" }}</h4>
                    <div class="tools">
                        <v-btn icon @click="addModal.value = false"><v-icon>mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <v-card-text>
                  <v-container>
                      <vue-editor ref="editor" :editor-toolbar="customToolbar" 
                                v-model="note"
                                :hide-details="!responseErrors.note"
                                :error-mesasges="responseErrors.note" @focus="responseErrors.note=''">
                        </vue-editor>
                      <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="regular" @click="addModal.value = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                          <v-btn color="primary" @click="saveNote" :loading="saving">{{ $page.props.lang.save || "Save" }}</v-btn>
                      </v-card-actions>
                  </v-container>
                </v-card-text>
            </v-card>
        </template>
        </v-dialog>
</template>

<script>
import { VueEditor, Quill } from "vue2-editor";
import EventBus from '@/js/eventbus'

export default {
     props:{
        event_id: {
            type: Number,
            required: true
        },
     },
     components: { VueEditor },
     data(){
        return {
            note: '',
            saving: false,
            responseErrors: {},
            customToolbar: [  ["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }] ]
        }
     },
     methods:{
        saveNote(){
             let payload = {
                notable_id: this.event_id,
                description: this.note,
                is_private: true
            };
            this.saving = true;
            axios.post('/backoffice/calendar/addNote', payload)
                .then(response => {
                    this.saving = false;
                    if(response.data.status==="OK") {
  
                        EventBus.$emit('SHOW_NOTIFICATION',{
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                      this.addModal = false;
                    }
                })
                .catch(error => {
                    this.saving = false;
                    EventBus.$emit('SHOW_NOTIFICATION',{
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                });
        }
     }
}
</script>
